<template>
  <div class="table-header">
    <div class="grid-string">
      <div class="cell import-cell cell-header cell-header_choice" />
      <v-menu v-for="field in order" :key="field.slug" offset-y class="cell-header_choice">
        <template v-slot:activator="{ on, attrs }">
          <div
            class="cell import-cell cell-header cell-header_choice capitalize"
            v-bind="attrs"
            v-on="on"
          >
            <span>
              {{
                ($t(getValue(field)) &&
                  ($t(getValue(field).systemText) || $t(getValue(field).text))) ||
                'сhoose'
              }}
            </span>
            <Icon type="chevron-down" color="secondary" size="16" class="ml-auto" />
          </div>
        </template>
        <DropdownMenu>
          <DropdownMenuElement
            v-for="option in options"
            :key="option.slug"
            @click.native="change(option, field)"
          >
            <div class="capitalize">
              {{ option.text }}
              <span v-if="option.required" class="required">*</span>
            </div>
          </DropdownMenuElement>
        </DropdownMenu>
      </v-menu>
    </div>
  </div>
</template>

<script>
  import { VMenu } from 'vuetify/lib';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import DropdownMenu from '@/components/ui/dropdown-menu/DropdownMenu';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'ImportListChoiceRow',
    components: { Icon, DropdownMenu, VMenu, DropdownMenuElement },
    props: {
      order: {
        type: Array,
        default: () => [],
      },

      fakes: {
        type: Array,
        default: () => [],
      },
      options: {
        type: Array,
        default: () => [],
      },
    },
    methods: {
      getValue(field) {
        const fake = this.fakes.find((fake) => fake.current === field.slug);

        if (fake) return fake;
        if (field.recognized === 'ignore') return this.options[0];
        if (field.recognized === 'custom') return this.options[1];
        return field;
      },
      change(option, field) {
        this.$emit('recognize', { field, val: option });
      },
    },
  };
</script>
